<template>
    <div>
        <div v-if="currentOrderDetails">
            <div
                v-if="currentOrderDetails.status.id != 1"
                style="margin-bottom: 75px; text-align: center; overflow: auto"
            >
                <div style="width: 960px; margin: auto; height: 90px">
                    <order-steps
                        :active="currentOrderDetails.status.id"
                    ></order-steps>
                </div>
            </div>
            <div
                style="margin-bottom: 25px; display: flex; align-items: center"
            >
                <p class="order-id" style="color: #6c757d; font-weight: 500">
                    {{ $t("Order number") }}:
                    {{ currentOrderDetails.identifier }}
                </p>
            </div>

            <!-- <div
                v-if="
                    currentOrderDetails.status.id == 13 &&
                    !currentOrderDetails.is_picked
                "
                style="display: flex; align-items: center; margin-bottom: 20px"
            >
                <p class="margin: 0">
                    {{ $t("Please schedule a pick-up time from here") }}
                </p>
                <button
                    @click="isPickupOpen = true"
                    style="margin: 0 5px"
                    class="button hint"
                >
                    {{ $t("Schedual pickup now") }}
                </button>
            </div> -->

            <div
                class="card-type"
                v-if="
                    currentOrderDetails.status.id == 13 &&
                    currentOrderDetails.is_picked
                "
            >
                <div class="head">
                    <p>{{ $t("Pickup details") }}</p>
                    <p>
                        <span style="color: #777; padding: 0 7px"
                            >{{ $t("Pickup comfirmation") }}:</span
                        >
                        <span style="font-weight: bold">{{
                            currentOrderDetails.pickup[0].vendor_reference
                        }}</span>
                    </p>
                </div>

                <div class="card-body">
                    <div class="c-left">
                        <p
                            style="
                                font-weight: bold;
                                color: #555;
                                font-size: 40px;
                            "
                        >
                            {{
                                currentOrderDetails.pickup[0].pickup_date
                                    | moment("dddd")
                            }}
                        </p>
                        <p style="color: #999; font-size: 20px">
                            {{
                                currentOrderDetails.pickup[0].pickup_date
                                    | moment("MMM DD, YYYY")
                            }}
                        </p>
                        <p style="font-weight: bold; font-size: 40px">
                            <span>
                                {{
                                    currentOrderDetails.pickup[0].pickup_date
                                        | moment("hh:mm a")
                                }}
                            </span>
                            <span> - </span>
                            <span>{{
                                ("01-08-1996 " +
                                    currentOrderDetails.pickup[0].close_time)
                                    | moment("hh:mm a")
                            }}</span>
                        </p>
                    </div>
                    <div class="c-right">
                        <p style="margin-bottom: 30px">
                            {{ $t("Instructions") }}:
                        </p>
                        <p>
                            {{
                                $t(
                                    "Please meet the driver at the front door of your building, or leave the shipment on the front desk of your housing office if available. In some cases the driver does not come on-time, so please contact vendor customer service in your country."
                                )
                            }}
                        </p>
                        <button class="button">
                            {{ $t("Contact customer service") }}
                        </button>
                    </div>
                </div>
            </div>
            <div
                class="card-type"
                v-if="
                    currentOrderDetails.status.id == 4 &&
                    currentOrderDetails.is_picked
                "
            >
                <div class="head">
                    <p>{{ $t("Estimated delivery date") }}</p>
                    <p>
                        <span style="color: #777; padding: 0 7px"
                            >{{ $t("Tracking Number") }}:</span
                        >
                        <span style="font-weight: bold">
                            {{ currentOrderDetails.vendor_shipment_id }}
                        </span>
                    </p>
                </div>

                <div class="card-body">
                    <div class="c-left">
                        <p style="font-weight: bold; color: #555">
                            {{
                                currentOrderDetails.deliver_time
                                    | moment("dddd")
                            }}
                        </p>
                        <p style="color: #777">
                            {{
                                currentOrderDetails.deliver_time
                                    | moment("MMM DD, YYYY")
                            }}
                        </p>
                    </div>
                    <div class="c-right">
                        <p style="margin-bottom: 30px">{{ $t("Note") }}:</p>
                        <p>
                            {{
                                $t(
                                    "Please meet the driver at the front door of your building, or leave the shipment on the front desk of your housing office if available. In some cases the driver does not come on-time, so please contact DHL customer service in your country."
                                )
                            }}
                        </p>
                    </div>
                </div>
            </div>
            <div class="card-type">
                <div class="head">
                    <p>{{ $t("Addresses information") }}</p>
                </div>

                <div class="card-body">
                    <div class="c-left">
                        <p class="card-title">{{ $t("Shipper:") }}</p>
                        <span
                            class="span-text name-bold"
                            style="margin-bottom: 15px"
                        >
                            {{
                                getName(
                                    currentOrderDetails.origin.first_name,
                                    currentOrderDetails.origin.second_name,
                                    currentOrderDetails.origin.last_name
                                )
                            }}
                        </span>

                        <div class="address-view">
                            <div class="view-item">
                                <p style="font-weight: bold">
                                    {{ $t("Email") }}:
                                </p>
                                <p>{{ currentOrderDetails.origin.email }}</p>
                            </div>
                            <div class="view-item">
                                <p style="font-weight: bold">
                                    {{ $t("Phone:") }}
                                </p>
                                <p style="direction: ltr !important">
                                    {{ currentOrderDetails.origin.mobile }}
                                </p>
                            </div>
                            <div class="view-item">
                                <p style="font-weight: bold">
                                    {{ $t("Company name:") }}
                                </p>
                                <p>{{ currentOrderDetails.origin.company }}</p>
                            </div>

                            <div class="view-item" style="flex-wrap: wrap">
                                <p style="font-weight: bold">
                                    {{ $t("Location:") }}
                                </p>
                                <div style="width: 100%">
                                    <p>
                                        {{ currentOrderDetails.origin.street }}
                                    </p>
                                    <p>
                                        {{
                                            currentOrderDetails.origin
                                                .address_two
                                        }}
                                    </p>
                                    <p>
                                        {{
                                            `${
                                                currentOrderDetails.origin.city
                                            } ${
                                                currentOrderDetails.origin.state
                                                    ? currentOrderDetails.origin
                                                          .state
                                                    : ""
                                            } ${currentOrderDetails.origin.zip}`
                                        }}
                                    </p>
                                    <p>
                                        {{
                                            currentOrderDetails.origin.country
                                                .nice_name
                                        }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="c-right">
                        <p class="card-title">{{ $t("Recipient:") }}</p>
                        <span
                            class="span-text name-bold"
                            style="margin-bottom: 15px"
                        >
                            {{
                                getName(
                                    currentOrderDetails.destination.first_name,
                                    currentOrderDetails.destination.second_name,
                                    currentOrderDetails.destination.last_name
                                )
                            }}
                        </span>

                        <div class="address-view">
                            <div class="view-item">
                                <p style="font-weight: bold">
                                    {{ $t("Email") }}:
                                </p>
                                <p>
                                    {{ currentOrderDetails.destination.email }}
                                </p>
                            </div>
                            <div class="view-item">
                                <p style="font-weight: bold">
                                    {{ $t("Phone:") }}
                                </p>
                                <p style="direction: ltr !important">
                                    {{ currentOrderDetails.destination.mobile }}
                                </p>
                            </div>
                            <div class="view-item">
                                <p style="font-weight: bold">
                                    {{ $t("Company name:") }}
                                </p>
                                <p>
                                    {{
                                        currentOrderDetails.destination.company
                                    }}
                                </p>
                            </div>

                            <div class="view-item" style="flex-wrap: wrap">
                                <p style="font-weight: bold">
                                    {{ $t("Location:") }}
                                </p>
                                <div style="width: 100%">
                                    <p>
                                        {{
                                            currentOrderDetails.destination
                                                .street
                                        }}
                                    </p>
                                    <p>
                                        {{
                                            currentOrderDetails.destination
                                                .address_two
                                        }}
                                    </p>
                                    <p>
                                        {{
                                            `${
                                                currentOrderDetails.destination
                                                    .city
                                            } ${
                                                currentOrderDetails.destination
                                                    .state
                                                    ? currentOrderDetails
                                                          .destination.state
                                                    : ""
                                            } ${
                                                currentOrderDetails.destination
                                                    .zip
                                            }`
                                        }}
                                    </p>
                                    <p>
                                        {{
                                            currentOrderDetails.destination
                                                .country.nice_name
                                        }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="shipment_info">
                <div class="card-type">
                    <div class="head">
                        <p>
                            {{ $t("Weight") }} &amp; {{ $t("Dimensions") }}
                            <span
                                class="hint"
                                v-if="currentOrderDetails.re_weighted"
                                >{{ $t("updated") }}</span
                            >
                        </p>

                        <p class="hint" v-if="!currentOrderDetails.re_weighted">
                            <span>
                                {{
                                    $t(
                                        "Estimated weight until the shipment get reweighed through"
                                    )
                                }}
                            </span>
                            <span style="margin: 2px">{{
                                currentOrderDetails.vendor_name
                            }}</span>
                        </p>
                    </div>
                    <div class="card-body">
                        <div class="title">
                            <p>
                                {{
                                    currentOrderDetails.re_weighted
                                        ? currentOrderDetails.re_weighted
                                              .final_weight
                                        : currentOrderDetails.total_weight
                                          | number("0,0.0")
                                }}
                                <span class="unit">{{ $t("KG") }}</span>
                            </p>
                        </div>

                        <div class="info">
                            <div class="key">
                                <p>{{ $t("NO. of packages") }}</p>
                                <p>{{ $t("Customer weight") }}</p>
                                <p>{{ $t("Vendor weight") }}</p>
                                <button class="button">
                                    {{ $t("More details") }}
                                </button>
                            </div>
                            <div class="value">
                                <p>
                                    {{
                                        currentOrderDetails.packages.reduce(
                                            (a, b) => {
                                                return (a += b.quantity);
                                            },
                                            0
                                        )
                                    }}
                                </p>
                                <p>
                                    {{
                                        currentOrderDetails.re_weighted
                                            ? currentOrderDetails.re_weighted
                                                  .user_weight
                                            : currentOrderDetails.total_weight
                                              | number("0,0.0")
                                    }}
                                    {{ $t("KG") }}
                                </p>
                                <p>
                                    {{
                                        currentOrderDetails.re_weighted
                                            ? currentOrderDetails.re_weighted
                                                  .final_weight
                                            : 0 | number("0,0.0")
                                    }}
                                    {{ $t("KG") }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-type">
                    <div class="head">
                        <p>
                            {{ $t("Total shipment cost") }}
                            <span
                                class="hint"
                                v-if="currentOrderDetails.re_weighted"
                                >{{ $t("updated") }}</span
                            >
                        </p>
                        <p class="hint" v-if="!currentOrderDetails.re_weighted">
                            <span>
                                {{
                                    $t(
                                        "Estimated price until the shipment get reweighed through"
                                    )
                                }}
                            </span>
                            <span style="margin: 2px">{{
                                currentOrderDetails.vendor_name
                            }}</span>
                        </p>
                    </div>

                    <div class="card-body">
                        <div class="title">
                            <p>
                                {{
                                    currentOrderDetails.total_price
                                        | currency("")
                                }}
                                <span class="unit">{{ $t("SAR") }}</span>
                            </p>
                        </div>

                        <div class="info">
                            <div class="key">
                                <p>{{ $t("Shipping fee") }}</p>
                                <p>{{ $t("Oversizing fee") }}</p>
                                <p>{{ $t("Protection") }}</p>
                                <p>{{ $t("Pick up Fee") }}</p>
                                <p v-if="currentOrderDetails.re_weighted">
                                    {{ $t("New Weight Charge") }}({{
                                        currentOrderDetails.re_weighted
                                            .final_weight -
                                        currentOrderDetails.re_weighted
                                            .user_weight
                                    }}
                                    {{ $t("KG") }})
                                </p>
                            </div>
                            <div class="value">
                                <p>
                                    {{
                                        currentOrderDetails.shipment_fees
                                            | currency("")
                                    }}
                                    {{ $t("SAR") }}
                                </p>
                                <p>0 {{ $t("SAR") }}</p>
                                <p>
                                    {{
                                        currentOrderDetails.insurance_fees
                                            | currency("")
                                    }}
                                    {{ $t("SAR") }}
                                </p>
                                <p>0 {{ $t("SAR") }}</p>
                                <p v-if="currentOrderDetails.re_weighted">
                                    {{
                                        currentOrderDetails.re_weighted
                                            .charge_amount | currency("")
                                    }}
                                    {{ $t("SAR") }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card-type table-card">
                <div class="head">
                    <p>{{ $t("Contents") }}</p>
                </div>
                <div class="card-body">
                    <b-table id="sm-table" :data="currentOrderDetails.contents">
                        <template slot-scope="props">
                            <b-table-column
                                field="item"
                                :label="$t('Item')"
                                :centered="true"
                                >{{ props.row.title }}</b-table-column
                            >
                            <b-table-column
                                field="quantity"
                                :label="$t('Quantity')"
                                :centered="true"
                                >{{ props.row.quantity }}</b-table-column
                            >
                            <b-table-column
                                field="net_weight"
                                :label="$t('Total Weight')"
                                :centered="true"
                            >
                                {{ props.row.net_weight }}
                                {{ $t("KG") }}
                            </b-table-column>
                            <b-table-column
                                field="item_value"
                                :label="$t('Total Price')"
                                :centered="true"
                            >
                                {{ props.row.item_value }}
                                {{ $t("SAR") }}
                            </b-table-column>
                        </template>
                    </b-table>
                </div>
            </div>
            <b-modal
                :active.sync="isPickupOpen"
                trap-focus
                aria-role="dialog"
                aria-modal
                scroll="clip"
            >
                <pickup :orders="[currentOrderDetails.id]" />
            </b-modal>
        </div>
    </div>
</template>

<script>
import moment from "moment";
import OrderSteps from "@/components/OrderSteps.vue";
import pickup from "@/components/modal/pickup.vue";
// import Loading from "@/components/Loading";

export default {
    components: {
        OrderSteps,
        pickup,
        // Loading,
    },
    data() {
        return {
            isPickupOpen: false,
        };
    },
    created() {
        if (
            isNaN(this.$route.params.id) ||
            this.$route.params.id < 1 ||
            this.$route.params.id == undefined
        ) {
            this.$buefy.toast.open({
                message: this.$t("Order not found"),
                type: "is-primary",
            });
            this.$router.push({ name: "my-shipment" });
            return;
        }
        this.$store.dispatch("orderDetails", this.$route.params.id);
    },
    computed: {
        currentOrderDetails() {
            return this.$store.getters.getCurrentOrderDetails;
        },
    },
    methods: {
        tracking(vendor, id) {
            switch (vendor) {
                case "DHL":
                    window.open(
                        `https://www.dhl.com.sa/en/express/tracking.html?AWB=${id}&brand=DHL`,
                        "_blank"
                    );
                    break;
                case "FedEx":
                    window.open(
                        `https://www.fedex.com/apps/fedextrack/?action=track&trackingnumber=${id}&cntry_code=us&locale=en_US`,
                        "_blank"
                    );
                    break;
                default:
                    window.open(
                        "https://support.wwf.org.uk/earth_hour/index.php?type=individual",
                        "_blank"
                    );
            }
        },
        totalWeight(length, width, height, weight, unit) {
            var totalWeight = (length * width * height) / 5000;
            return totalWeight > weight ? totalWeight : weight + unit;
        },
        getName(firstName, secondName, lastName) {
            return `${firstName || ""} ${secondName || ""} ${lastName || ""}`;
        },
        getAddress(state, city, zipCode) {
            return `${city || ""}, ${state || ""} ${zipCode || ""}`;
        },
        moment(date) {
            var validDate = null;
            if (date.includes("GMT" || "UTC")) {
                validDate = date.toString().substr(0, date.lastIndexOf("GMT"));
            } else {
                validDate = date;
            }
            return moment(validDate).format("MMMM Do YYYY, h:mm a");
        },
    },
};
</script>

<style lang="scss" scoped>
.hint,
.in-progress {
    background: #ff7977;
    padding: 1px 10px;
    border-radius: 10px;
    font-size: 12px !important;

    &.in-progress {
        background: #4952ff;
    }
}

.address-view {
    .view-item {
        display: flex;
        align-items: center;
        padding: 8px 0;

        p {
            padding: 0 5px;
            margin: 0;
        }
    }
}

.claim {
    .card-body {
        display: block !important;

        .item {
            .avatar {
                margin: 0 20px 0 0;

                img {
                    width: 60px;
                    border-radius: 50%;
                }
            }

            display: flex;

            .content {
                border-bottom: 4px solid #f7f7f7;
                padding-bottom: 30px;
                margin-bottom: 30px;
                margin-right: 50px;
                display: flex;

                .comment {
                    width: 50%;

                    .name {
                        margin-top: 10px;
                        font-size: 20px;
                        font-weight: bold;
                    }
                }

                .attachments {
                    width: 50%;
                    text-align: center;

                    .title {
                        margin-top: 10px;
                        font-size: 20px;
                        font-weight: bold;
                    }
                }
            }

            &:last-of-type {
                .content {
                    border: none;
                }
            }
        }
    }
}

.shipment_info {
    display: flex;
    justify-content: space-between;

    .card-type {
        width: 48%;

        .card-body {
            flex-wrap: wrap;

            .title {
                width: 100%;
                font-size: 40px;
                display: flex;
                justify-content: center;
                flex-wrap: wrap;

                p {
                    border-bottom: 2px solid #f7f7f7;
                    padding-bottom: 10px;
                    letter-spacing: 1px;

                    span {
                        font-size: 18px;
                    }
                }
            }

            .info {
                width: 90%;
                margin: auto;
                display: flex;
                color: #6c757d;

                .key {
                    width: 65%;
                    font-weight: bold;

                    button {
                        font-size: 12px;
                        padding: 0 10px;
                        margin: 7px 0;
                        height: auto;
                        border-radius: 20px;
                    }
                }

                .value {
                    width: 35%;
                }
            }
        }
    }
}

.card-type {
    background-color: white;
    min-height: 300px;
    border-radius: 5px;
    box-shadow: 0 8px 15px 0 rgba(217, 217, 217, 0.3);
    margin-bottom: 20px;

    .head {
        padding: 20px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 2px solid #f7f7f7;
        font-weight: bold;

        p {
            font-size: 16px;
            color: black;
        }
    }

    .card-body {
        padding: 20px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .c-left {
            width: 52%;
        }

        .c-right {
            width: 48%;

            button {
                font-size: 16px;
                padding: 0 10px;
                margin: 10px 0;
                height: auto;
                border-radius: 20px;
            }
        }
    }

    .left-right {
        color: #6c757d;

        span {
            display: inline-block;
        }

        .pick-up-title {
            width: 100%;
            text-align: center;
            font-weight: 500;
            margin-bottom: 5px;
        }

        .to-left {
            text-align: left;
            width: 50%;
        }

        .to-right {
            text-align: right;
            width: 50%;
        }
    }

    .card-title {
        font-weight: 500;
        color: #555;
        font-size: 30px !important;
    }

    .span-text {
        display: block;
        color: #6c757d;
    }

    .name-bold {
        font-weight: 500;
        font-size: 1.1rem;
    }
}

::v-deep {
    .b-table {
        margin: auto;
        width: 90% !important;
    }

    .card-type .b-table .table th {
        background-color: white !important;
        border-bottom: 2px solid #f7f7f7;
    }

    .card-type .table td {
        border: none !important;
    }
}

@media screen and (max-width: 1000px) {
    .card-type {
        .head {
            p {
                font-size: 16px;
            }
        }

        .card-body {
            .card-title {
                font-size: 22px !important;
            }

            .span-text {
                font-size: 18px !important;
            }

            .address-view {
                .view-item {
                    p {
                        font-size: 14px !important;
                    }
                }
            }
        }
    }
}

@media screen and (max-width: 750px) {
    .order-id {
        font-size: 14px !important;
    }

    .card-type {
        .head {
            p {
                font-size: 14px;
            }
        }

        .card-body {
            flex-wrap: wrap !important;

            .c-left,
            .c-right {
                width: 100% !important;
            }

            .c-right {
                border-top: 1px solid #ddd;
                margin-top: 5px;
                padding-top: 5px;
            }

            .card-title {
                font-size: 22px !important;
            }

            .span-text {
                font-size: 18px !important;
            }

            .address-view {
                .view-item {
                    p {
                        font-size: 14px !important;
                    }
                }
            }
        }
    }

    .shipment_info {
        flex-wrap: wrap;

        .head {
            flex-wrap: wrap;

            p {
                width: 100%;
            }
        }

        .card-type {
            width: 100%;
        }

        .card-body {
            .info {
                .key {
                    font-size: 14px;
                }
            }
        }
    }

    .table-card {
        .card-body {
            padding: 0 10px 20px !important;

            .b-table {
                margin: 0 !important;
                width: 100% !important;
            }
        }
    }
}
</style>
